import React from 'react'
import { FieldWrapper } from '@progress/kendo-react-form'
import { Label, Error, Hint } from '@progress/kendo-react-labels'
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { useTranslation } from "react-i18next"

const FormDatePicker = (fieldRenderProps) => {
  const { t } = useTranslation()
  const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, hintDirection, min, value, ...others } = fieldRenderProps
  const showValidationMessage = touched && validationMessage
  const showHint = !showValidationMessage && hint
  const hintId = showHint ? `${id}_hint` : ''
  const errorId = (showValidationMessage) ? `${id}_error` : ''
  const labelId = label ? `${id}_label` : ''
  const newValid = (value < min) ? false : valid
  return (
    <FieldWrapper style={wrapperStyle}>
      <Label id={labelId} editorId={id} editorValid={valid} editorDisabled={disabled}>
        {label}
      </Label>
      <div className={'k-form-field-wrap'}>
        <DatePicker
          ariaLabelledBy={labelId}
          ariaDescribedBy={`${hintId} ${errorId}`}
          formatPlaceholder={{
            day: t('formDatePicker.day'),
            month: t('formDatePicker.month'),
            year: t('formDatePicker.Year')
          }}
          valid={newValid}
          id={id}
          disabled={disabled}
          min={min}
          value={value}
          {...others}
        />
        {
          showHint &&
          <Hint id={hintId} direction={hintDirection}>{hint}</Hint>
        }
        {
          (showValidationMessage || (value < min)) &&
          <p id={errorId} style={{
            fontSize: "12px",
            color: "black"
          }}
          >{"La nueva fecha propuesta no puede ser menor a 60 días a partir de la fecha de solicitud de firma y no puede ser menor a la ya establecida en la solicitud."}</p>
          // && <Error id={errorId}>{validationMessage || "La nueva fecha propuesta no puede ser menor a 60 días a partir de la fecha de solicitud de firma y no puede ser menor a la ya establecida en la solicitud."}</Error>
        }
      </div>
    </FieldWrapper >
  )
}

export { FormDatePicker as default }